import { QuoteSearchResponse } from '@lio/api-types';
import { LioUserRole, BrokerageUserRole } from '@lio/rule-engine';

import { ArrayItem } from '@utils/commonTypes';

export const UserRoles = { ...LioUserRole, ...BrokerageUserRole, Quoter: 'Quoter' };

export type UserRole = typeof UserRoles;

export const allRoles: string[] = Object.values(UserRoles);
export const allButLioSales = allRoles.filter((el) => el !== UserRoles.LioSales);
export const allButCsr = allRoles.filter((el) => el !== UserRoles.CSR);

export const internalRoles = [
  UserRoles.SystemAdmin,
  UserRoles.Underwriter,
  UserRoles.LIOContractor,
  UserRoles.JrOps,
  UserRoles.SrOps,
  UserRoles.LioSales,
  UserRoles.PortalAdmin,
];

export type UserClaimsResponse = {
  firstName: string;
  lastName: string;
  email: string;
  roles: string[];
};

export interface IUserClaims {
  firstName: string;
  lastName: string;
  fullName: string;
  email?: string;
  roles?: UserRole[];
}

export interface LioUser {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  userId: string;
  role: LioUserRole;
}

export type BrokerageUser = {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  role: BrokerageUserRole | null;
  userId: string;
  brokerageId: string | null;
};

export interface BrokerageProducer {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  userId: string;
  brokerageId: string;
}

export interface Underwriter {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  userId: string;
}

export type QuoteSearch = ArrayItem<QuoteSearchResponse['items']>;
